module.exports = __webpack_public_path__ + "static/img/11_common_info.a9953f3.png";